// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__I2-HD","links":"Footer_links__lTXh1","logo":"Footer_logo__1LYaY","copyright":"Footer_copyright__XJlVz","linkItem":"Footer_linkItem__Jxroa"};